import PolicyApplicabilityStepSection from "../../policy-wizard/PolicyApplicabilityStepSection";

/** Maps salary structure assignment ↔ policy applicability shape. */
export function assignmentToApplicability(assignment = {}) {
  if (assignment.allEmployees != null || assignment.branch === "" || typeof assignment.branch === "string") {
    return {
      allEmployees: !!assignment.allEmployees,
      branch: assignment.branch || "",
      department: assignment.department || "",
      designation: assignment.designation || "",
      grade: assignment.grade || "",
      category: assignment.category || "",
      subDepartment: assignment.subDepartment || assignment.subdepartment || "",
      location: assignment.location || "",
      employmentTypes: assignment.employmentTypes || assignment.employmentType || [],
      employeeIds: assignment.employeeIds || assignment.employees || [],
    };
  }
  return {
    allEmployees: false,
    branch: assignment.branch?.[0] || "",
    department: assignment.department?.[0] || "",
    designation: assignment.designation?.[0] || "",
    grade: assignment.grade?.[0] || "",
    category: assignment.category?.[0] || "",
    subDepartment: assignment.subdepartment?.[0] || "",
    location: "",
    employmentTypes: assignment.employmentType || [],
    employeeIds: assignment.employees || [],
  };
}

export function applicabilityToAssignment(policySlice) {
  return {
    allEmployees: !!policySlice.allEmployees,
    branch: policySlice.branch || "",
    department: policySlice.department || "",
    designation: policySlice.designation || "",
    grade: policySlice.grade || "",
    category: policySlice.category || "",
    subDepartment: policySlice.subDepartment || "",
    location: policySlice.location || "",
    employmentTypes: policySlice.employmentTypes || [],
    employeeIds: policySlice.employeeIds || [],
  };
}

export default function SalaryStructureApplicabilityStep({
  assignment,
  onAssignmentChange,
  masterLists = {},
  darkMode = false,
  employeePicker = null,
}) {
  const policy = assignmentToApplicability(assignment);

  const setPolicy = (updater) => {
    const next = typeof updater === "function" ? updater(policy) : updater;
    onAssignmentChange(applicabilityToAssignment(next));
  };

  const toggleEmploymentType = (value) => {
    setPolicy((p) => {
      const current = Array.isArray(p.employmentTypes) ? p.employmentTypes : [];
      const employmentTypes = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];
      return { ...p, employmentTypes };
    });
  };

  return (
    <PolicyApplicabilityStepSection
      darkMode={darkMode}
      policy={policy}
      setPolicy={setPolicy}
      branchesList={masterLists.branchesList || []}
      departmentsList={masterLists.departmentsList || []}
      designationsList={masterLists.designationsList || []}
      gradesList={masterLists.gradesList || []}
      categoriesList={masterLists.categoriesList || []}
      subDepartmentsList={masterLists.subDepartmentsList || []}
      onToggleEmploymentType={toggleEmploymentType}
      title="Structure Applicability"
      allEmployeesLabel="Apply to all employees (all branches / departments / …)"
      employmentTypesHelp=""
      showEmploymentTypesHelp={false}
      /* Location is not a Masters entry — only Branch/Dept/Desig/Grade/Category/Sub-Dept */
      showLocation={false}
    >
      {employeePicker}
    </PolicyApplicabilityStepSection>
  );
}
